module.exports = __webpack_public_path__ + "static/media/rPaul.7a294438.jpeg";